<template lang="pug">
#global-nav
  nav.navbar.is-fixed-top(:class="{ 'is-transparent': transparent, 'is-solid': !transparent, 'is-sticky': sticky }")
    .container.is-fluid
      .navbar-brand
        router-link.navbar-item(
          :to="{ name: 'home' }"
          :class="{ 'is-active': activePage === 'home' }"
        )
          img(src="/images/cwo/cwo-crest.png" v-if="account.abbreviation === 'CWO'")
          span {{ account.organization_short }}
          //- span.organization_full {{ account.organization }}
        button.button.navbar-burger(:class="{ 'is-dark': dark }" @click="toggleDrawer")
          span
          span
          span
      .navbar-menu
        .navbar-start
          router-link.navbar-item(
            :to="{ name: 'services' }"
            :class="{ 'is-active': activePage === 'services' || activePage === 'speaker' || activePage === 'collection' }"
          )
            span Services
          router-link.navbar-item(
            v-if="account.abbreviation === 'FFC'"
            :to="{ name: 'tv' }"
            :class="{ 'is-active': activePage === 'tv' }"
          )
            span TV
          router-link.navbar-item(
            :to="{ name: 'calendar', query: { page:1 } }"
            :class="{ 'is-active': activePage === 'calendar' || activePage === 'event' || activePage === 'eventSignup' }"
          )
           span Calendar
          router-link.navbar-item(
            :to="{ name: 'projects' }"
            :class="{ 'is-active': activePage === 'projects' || activePage === 'project' }"
          )
            span Projects
          router-link.navbar-item(
            :to="{ name: 'ministries' }"
            :class="{ 'is-active': activePage === 'ministries' || activePage === 'ministry' }"
          )
            span Ministries
          router-link.navbar-item(
            :to="{ name: 'articles' }"
            :class="{ 'is-active': activePage === 'articles' || activePage === 'article' }"
          )
            span Articles
          b-dropdown
            .navbar-item(slot="trigger")
              .navbar-link About Us
            b-dropdown-item(has-link)
              router-link(:to="{ name: 'believe' }") What We Believe
            b-dropdown-item(has-link)
              router-link(:to="{ name: 'times' }") Service Times
            //- b-dropdown-item(has-link)
            //-   router-link(:to="{ name: 'faq' }") FAQ
            b-dropdown-item(has-link)
              router-link(:to="{ name: 'staffMembers' }") Pastoral Staff
            b-dropdown-item(has-link)
              router-link(:to="{ name: 'materials' }") Resources
            b-dropdown-item(has-link)
              router-link(:to="{ name: 'siouxCity' }") Sioux City, Iowa
            b-dropdown-item(has-link)
              router-link(:to="{ name: 'contact' }") Contact Us
        .navbar-end
          router-link.navbar-item(:to="{ name: 'membership' }")
            .button.is-light Become a Member
          a.navbar-item(
            v-if="account.giving_link"
            :href="account.giving_link"
            target="_blank"
          )
            .button.is-primary
              span Online Giving
              b-icon(icon="arrow-right" size="is-small")
          //- .navbar-item.has-text-grey-light
          //-   b-icon(icon="magnify")
        .navbar-active(:style="`left:${activeOffset}px;`" v-if="activeOffset >= 0")
    .navbar-bg
</template>

<script>
import { mapGetters } from 'vuex';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'app-navbar',
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      channel: getterTypes.GET_CHANNEL,
      drawer: getterTypes.GET_DRAWER,
    }),
    activeOffset() {
      let index = -1;
      switch (this.activePage) {
        case 'services':
        case 'episode':
        case 'collection':
        case 'speaker':
          index = 0;
          break;
        case 'calendar':
        case 'event':
          index = 1;
          break;
        case 'projects':
        case 'project':
          index = 2;
          break;
        case 'ministries':
        case 'ministry':
          index = 3;
          break;
        case 'articles':
        case 'article':
          index = 4;
          break;
        default:
      }
      return index * 100;
    },
    activePage() {
      if (this.$route.name === 'episode' && this.channel !== undefined) {
        if (this.channel.title === 'Television') {
          return 'tv';
        }
        return 'services';
      }
      return this.$route.name;
    },
    dark() {
      const routes = [
        // 'episode',
        // 'event',
        // 'registrationConfirmation',
        'christmas',
      ];
      return routes.includes(this.$route.name);
    },
    isMobile() {
      return window.innerWidth <= 769;
    },
    pages() {
      return this.account._embedded.pages;
    },
    transparent() {
      return this.activePage === 'home' && !this.isMobile;
    },
  },
  data() {
    return {
    };
  },
  methods: {
    toggleDrawer() {
      this.$store.commit(mutationTypes.SET_DRAWER, !this.drawer);
    },
  },
  props: {
    sticky: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
#global-nav {
  .dropdown {
    .dropdown-content {
      box-shadow: 0 6px 30px rgba(0,0,0,0.1);
      border: none;
      min-width: 300px;
    }
  }
}
</style>

<style lang="scss" scoped>
nav {
  z-index: 20 !important;
  border-bottom: none;
  .navbar-bg {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    transform: translate3d(0, -100px, 0);
    transition: 0.25s transform ease-in-out;
    background-color: $primary;
  }
  .navbar-active {
    width: 100px;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 4px;
    transition: 0.35s left ease-in-out;
  }
  &.is-transparent {
    background-color: transparent;
    box-shadow: none;
    transition: 0.35s color ease-in-out;
    .navbar-item, .navbar-link {
      transition: 0.35s color ease-in-out;
    }
  }
  &.is-transparent:not(.is-sticky) {
    .navbar-item, .navbar-link {
      &, &.is-active {
        color: $white;
      }
      &:hover {
        color: $primary;
      }
    }
  }
  &:not(.is-transparent) {
    background-color: $primary;
    box-shadow: 0 3px 22px rgba(0,0,0,0.05);
  }
  &.is-sticky {
    .navbar-bg {
      transform: translate3d(0, 0, 0);
    }
  }
  &.navbar {
    min-height: $navbar-height;
  }
  // &.is-dark {
  //   background-color: $dark-navbar;
  // }
  // &.is-dark, &.is-black {
  //   border-bottom: none;
  // }
  .container.is-fluid {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    margin-left: 0;
    margin-right: 0;
    position: relative;
    z-index: 2;
  }
  .navbar-brand {
    a {
      padding-left: 0.5rem;
      font-weight: 600;
      font-size: 1.10rem;
    }
    .navbar-burger {
      border-radius: 0;
    }
  }
  .navbar-link {
    &:hover {
      background-color: transparent;
      color: $white;
    }
  }
  .navbar-burger {
    border: none;
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }
  }
  .navbar-end {
    .navbar-item + .navbar-item {
      padding-left: 0;
    }
  }
}
@media (max-width: $tablet) {
  nav {
    .container.is-fluid {
      padding-left: 0.85rem;
      padding-right: 0;
    }
    .organization_full {
      display: none;
    }
    .navbar-item {
      &:hover {
        background-color: transparent !important;
      }
    }
  }
}
@media (min-width: $tablet) {
  nav {
    .organization_short {
      display: none;
    }
  }
}
</style>

<style theme="ffc" lang="scss" scoped>
nav {
  background-color: $primary;
  border-bottom: none;
  .navbar-burger {
    color: #88c2e0;
  }
  .navbar-link {
    color: #88c2e0;
  }
  .navbar-link:not(.is-arrowless)::after {
    border-color: #88c2e0;
  }
  .navbar-item {
    // font-size: 0.9rem;
    color: #88c2e0;
    margin-bottom: -1px;
    > span {
      position: relative;
      top: 0;
    }
    .button.is-primary {
      font-weight: 500;
      background-color: #17668e;
    }
    &:hover, &:focus {
      background-color: transparent;
      color: $white;
    }
    &.is-active {
      color: $white;
      background-color: transparent;
      // color: $primary !important;
      // border-bottom: 4px solid $primary;
      // background-color: transparent;
      // span {
      //   top: 2px;
      // }
    }
  }
}
</style>

<style theme="cwo" lang="scss" scoped>
$navbar-item-color: $grey-darker;
$menu-item-width: 100px;
nav {
  // &:not(.is-sticky) {
  //   .button.is-light {
  //     color: $white;
  //     border-color: $white;
  //   }
  // }
  &:not(.is-transparent) {
    background-color: $white;
  }
  .navbar-bg {
    background-color: $white;
  }
  .navbar-active {
    background-color: #ecac1c;
  }
  .navbar-brand {
    .navbar-item {
      color: $navbar-item-color;
      font-family: $heading-font;
      font-weight: normal;
      font-size: 1.2rem;
      text-transform: uppercase;
      &.is-active, &:hover {
        background-color: transparent;
      }
      img {
        max-height: 3rem;
        margin-right: 0.5rem;
      }
      .organization_full {
        position: relative;
        top: -2px;
      }
    }
  }
  .navbar-menu {
    position: relative;
    .navbar-start {
      .navbar-item {
        width: $menu-item-width;
        white-space: nowrap;
        span {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
  .navbar-item, .navbar-link {
    transition: 0.35s background-color ease-in-out;
    color: $navbar-item-color;
    font-weight: normal;
    &:hover, &:focus {
      background-color: transparent;
      color: $navbar-item-color;
      outline: none;
    }
    &.is-active {
      color: $navbar-item-color;
    }
    .button {
      font-weight: 500;
      &.is-primary {
        background-color: #ecac1c;
      }
    }
  }
  .navbar-link:not(.is-arrowless)::after {
    border-color: #ecac1c;
  }
  .dropdown {
    .dropdown-trigger {
      .navbar-link {
        padding-left: 0;
      }
    }
    .dropdown-content {
      a {
        font-size: 1rem;
        padding: 1rem;
        &:hover {
          color: $primary;
          background-color: #fff8e7;
        }
      }
    }
  }
  @media (max-width: $tablet) {
    .container.is-fluid {
      padding: 0 0 0 0.5rem;
    }
  }
}
</style>
